define(
({
  "select_shipping_method": "Vyberte způsob dopravy"
})
);
